export function Offset() {
    return function (input, start, count) {
        start = parseInt(start, 10) - 1; //rl pager is 1 based, but the below is 0 based
        count - parseInt(count, 10);
        return input.slice(start * count, (start * count)+count);
    }
}

